import React from 'react';

export const EditDatesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6C3 4.34315 4.34315 3 6 3H14C15.6569 3 17 4.34315 17 6V9.00299C16.6586 9.01856 16.3194 9.09477 16 9.23163V7H4V14C4 15.1046 4.89543 16 6 16H9.47466C9.45904 16.0513 9.44469 16.1031 9.43163 16.1554L9.22047 17H6C4.34315 17 3 15.6569 3 14V6ZM10.9798 15.3772L15.8092 10.5478C16.5395 9.81741 17.7237 9.81741 18.454 10.5478C19.1843 11.2781 19.1843 12.4622 18.454 13.1926L13.6246 18.022C13.343 18.3036 12.9902 18.5033 12.6039 18.5999L11.106 18.9744C10.4546 19.1372 9.86451 18.5472 10.0274 17.8958L10.4018 16.3979C10.4984 16.0116 10.6982 15.6588 10.9798 15.3772Z"
      fill="#27B0E0"
    />
    <rect
      x="5.76636"
      y="9.05688"
      width="2.15576"
      height="1.88623"
      rx="0.943115"
      fill="#27B0E0"
    />
    <rect
      x="8.92212"
      y="9.05688"
      width="2.15576"
      height="1.88623"
      rx="0.943115"
      fill="#27B0E0"
    />
    <rect
      x="12.0779"
      y="9.05688"
      width="2.15576"
      height="1.88623"
      rx="0.943115"
      fill="#27B0E0"
    />
  </svg>
);
